"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
const material_1 = require("@angular/material");
let SisReportExportDialog = class SisReportExportDialog {
    constructor(data) {
        this.data = data;
        this.ExportPageOrientation = idm_report_export_service_client_js_1.ExportPageOrientation;
        this._exportPageOrientation = idm_report_export_service_client_js_1.ExportPageOrientation.PORTRAIT;
    }
    setExportPageOrientation(value) {
        this._exportPageOrientation = value;
    }
    exportReport() {
        this.data.addPageOrientation(this._exportPageOrientation);
        this.data.exportReport();
    }
    getSelectedExportType() {
        switch (this.data.selectedExportType) {
            case 0:
                return 'Excel';
            case 1:
                return 'Word';
            case 2:
                return 'PDF';
            default:
                throw new Error(`${this.data.selectedExportType} export type doesn't exist!`);
        }
    }
};
SisReportExportDialog = __decorate([
    core_1.Component({
        
        selector: "sis-report-export-dialog",
        styles: [require('./sis-report-export.dialog.css')],
        template: require('./sis-report-export.dialog.html')
    }),
    __param(0, core_1.Inject(material_1.MAT_DIALOG_DATA)),
    __metadata("design:paramtypes", [Object])
], SisReportExportDialog);
exports.SisReportExportDialog = SisReportExportDialog;
//# sourceMappingURL=sis-report-export.dialog.js.map